import React, { useState, useEffect, useRef } from 'react';
import { useParams } from "react-router-dom";
import api from "../services/api";

import LensPicker from './LensPickerFocus.js'
import BackArrow from '../partials/BackArrow.jsx'
import NearPicker from "./NearPickerFocus.js"
import Overview from './Overview.js'

import NightSimulator from './NightSimulatorFocus.js';
import snellenChart from "./images/snellenChart.png"
import nearImage from "./images/nearImage.png"
import Glasses from "./images/glassesRx.jpeg"

import { MdOutlineArrowBackIosNew } from "react-icons/md";

// import { FaCheck } from "react-icons/fa";
// import { MdDoNotDisturbAlt } from "react-icons/md";

// import api from "../services/api";
// import PrintPage from '../partials/PrintPage';

export default function VisionSimulator(props){


//=====================START QR interpretation==================================
  //take care of encryption
  const CryptoJS = require('crypto-js');

  //get qrdata from URL
  let { id } = useParams();
  //split URL data into token and encrypted qr data
  let qrText = id.split('.')
  //qr token as variable
  let qrToken = qrText[0]
  // console.log(qrToken)

  // use QR Token to get physican preference data
  const getQrEncryptionKey = async () => {
    
    try {
      const res = await api.post("/qrcoderead", {
        qrToken,
      });
  
      if (res.status === 200) {
        let encKey = (res.data[0].rows[0].qr_encryption_key);
        let intermediateText = qrText[1].replace(/-/g, "+").replace(/_/g, "/");
        // console.log(intermediateText)
        let decryptedText = CryptoJS.AES.decrypt(intermediateText, encKey);
        // console.log(decryptedText)
        let qrMeasurements = decryptedText.toString(CryptoJS.enc.Utf8);
        // console.log(qrMeasurements)
        // Split qrMeasurements to use throughout qrVisionSimulator
        let splitter = qrMeasurements.split('&');
        // console.log(splitter)
        // console.log(res.data.rows[0].qr_encryption_key);
        props.setSide(splitter[0]);
        props.setPower(splitter[1]);
        props.setCylinder(splitter[2]);
    
        props.setAxis(splitter[3])
        props.setAdd(splitter[4])
        props.setBcva(splitter[5])
        props.setNs(splitter[6])
        props.setBat(splitter[7])
        props.setBiometerAstig(splitter[8])
        props.setBiometerAxis(splitter[9])
        props.setChordMuTotal(splitter[10])
        props.setTopographerAstig(splitter[11])
        props.setTopographerAxis(splitter[12])
        props.setTopographerSphAb(splitter[13])
        props.setTopographerHoa(splitter[14])
        props.setCodeStatus(splitter[15])
        props.setAllergies(splitter[16])
        props.setLensOption(splitter[17]) 
        props.setQ1(splitter[18])
        props.setQ2(splitter[19])
        props.setQ3(splitter[20])
        props.setQ4(splitter[21])
        props.setQ5(splitter[22])
        props.setQ6(splitter[23])
        props.setQ7(splitter[24])
        props.setQ8(splitter[25])
        props.setQ9(splitter[26])
        props.setQ10(splitter[27])
        props.setQ11(splitter[28])
        props.setQ12(splitter[29])
        props.setQ13(splitter[30])
        props.setQ14(splitter[31])
        props.setPtName(splitter[32])
        props.setPtDob(splitter[33])
        props.setRefractiveFee(splitter[34])

        // use add-on name to modify addOn array of objects================
        const addOnString = `${splitter[35]}`;
        // console.log(addOnString)
        const addOnArray = addOnString.split(",");
        // console.log(addOnArray)
        const mergedAddOnArr = props.cataractAddOn.map(n => {
          if (addOnArray.includes(n.name)) {
            return { ...n, value: 'true' };
          }
          return n;
        });
        // console.log(mergedAddOnArr)
  
        props.setCataractAddOn(mergedAddOnArr); 
        //===========================================================

  
        //use contraindication name to modify contraindication array of objects
        if (res.data[1].rows.length !== 0 && res.data[1].rows !== undefined) {
          // Extract the contraindication names from the response
          const newArr = res.data[1].rows.flatMap(c => Object.values(c.contraindications).map(m => m.name));
  
    
          // Filter out duplicates and set all contraindication values to false
          const uniqueContraindications = [...new Set(newArr)].map(name => ({ name, value: 'false' }));
    
          // Split the string at the comma and map the contraindications to set their values to true
          const textString = `${splitter[36]}`;
          // console.log(textString)
          const textArray = textString.split(",");
          const mergedArr = uniqueContraindications.map(contra => {
            if (textArray.includes(contra.name)) {
              return { ...contra, value: 'true' };
            }
            return contra;
          });
    
          props.setContraindications(mergedArr);   
      }

        if(splitter[37]){
          props.setUserType(splitter[37])
        }

    }
  } catch (err) {
    // console.error(err.message);
  }
  }
 
  
  // use QR Token to get physican preference data
  const getMdPreferences = async () => {
    try {
      const res = await api.post("/qrcoderead", {
        qrToken,
      });
      if (res.status === 200) {


        // console.log(res.data[0].rows)
        // console.log(res.data[1].rows)
        // console.log(res.data[2].rows)
        // console.log(res.data[3].rows)
        // console.log(res.data[4].rows)
        // console.log(res.data[5].rows)
        // console.log(res.data[6].rows)
        // console.log(res.data[7].rows)
        // console.log(res.data[8].rows)

        if(res.data[1].rows.length > 0){
          props.setLensData(res.data[1].rows)
          Object.entries(res.data[1].rows).map(l => {
            if(l[1].lens_location === 'Sulcus'){
              props.setSulcusLens(l[1].lens_name)
            }
          })
        }

        if (res.data[3].rows.length > 0){
          props.setCriOffer(res.data[3].rows[0].cri_offer)
          props.setCriConsentId(res.data[3].rows[0].cri_consent)
          props.setFlacsOffer(res.data[3].rows[0].flacs_offer)
          props.setFlacsConsentId(res.data[3].rows[0].flacs_consent)
        } 

        if(res.data[4].rows.length > 0){
          props.setBiometer(res.data[4].rows[0].biometer_name)
          props.setTopographer(res.data[4].rows[0].topographer_name)
          props.setEquipmentPreference(res.data[4].rows[0].equipment_preference)
          props.setSphAbTarget(res.data[4].rows[0].sph_ab_target)
          props.setHoaMaxPreference(res.data[4].rows[0].hoa_max_preference)
        }

        if(res.data[5].rows.length > 0){
          props.setConsentData(res.data[5].rows)
        }

        if(res.data[6].rows.length > 0){
          props.setUseTutorial(res.data[6].rows[0].use_tutorial)
          props.setUseVideo(res.data[6].rows[0].use_video)
        } else{
          props.setUseTutorial(false)
          props.setUseVideo(false)
        }
       
        if(res.data[7].rows){
          props.setVideoData(res.data[7].rows)
        }
        
        if(res.data[8].rows.length > 0){
          props.setBedsheetData(res.data[8].rows[0].bedsheet_data)
          props.setBedsheetId(res.data[8].rows[0].bedsheet_id)
          props.setBedsheetUse(res.data[8].rows[0].bedsheet_use)
          props.setBedsheetName(res.data[8].rows[0].bedsheet_name)
        }
        

      }
    } catch (err) {
      console.error(err.message);
    }
  }


  useEffect(() => {
    getQrEncryptionKey();
    getMdPreferences();
  }, []);
  
  //=====================END QR interpretation==================================


  //Create phakic vision variables that come from patient info
    //phakicPower
    let p = (props.power.toLowerCase() === 'plano' ||
      props.power.toLowerCase() === 'pl' ||
      props.power === '')
        ? 0
        : props.power*1;

    //phakicCyl
    let c = (props.cylinder.toLowerCase() === 'sphere' ||
      props.cylinder.toLowerCase() === 'sph' ||
      props.cylinder === '')
        ? 0
        : props.cylinder*0.5;

    //phakicAdd
    let a = props.add*1;



    //First, get lens data for lens that matches lensOption -->
    let currentLens = [];
    if (props.lensData && Array.isArray(props.lensData)) {
      currentLens = props.lensData.filter(lens => (
        lens.lens_name === props.lensOption
      ));
    }
      // console.log(currentLens)
// need to make it so that when it changes to current vision, these things are set back to nothing
    //Then, create variables to store lens data
    useEffect(() => {
      if(currentLens.length > 0){
          props.setLensName(currentLens[0].lens_name)
          props.setLensModel(currentLens[0].model_number)
          props.setLensLocation(currentLens[0].lens_location)
          props.setLensHospitalFee(currentLens[0].hospital_lens_fee)
          props.setLensSphAb(currentLens[0].lens_sph_ab)
          props.setLensKSphAbResidual(currentLens[0].k_sph_ab_residual)
          props.setLensCorrectsIntermediateVision(currentLens[0].corrects_intermediate_vision)
          props.setLensCorrectsNearVision(currentLens[0].corrects_near_vision)
          props.setLensGlare(currentLens[0].lens_glare)
          props.setLensTopographerHoaCutoff(currentLens[0].lens_hoa_max)
          props.setLensKAstigMax(currentLens[0].lens_astig_max)
          props.setLensKAstigMin(currentLens[0].lens_astig_min)
          props.setLensKAstigResidual(currentLens[0].lens_astig_residual)
          props.setLensBiometerTopographerAstigCutoff(currentLens[0].biometer_topographer_astig_max)
          props.setLensBiometerTopographerAxisCutoff(currentLens[0].biometer_topographer_axis_max)
          props.setLensCriMinAstig(currentLens[0].cri_min_astig)
          props.setLensCriMaxAstig(currentLens[0].cri_max_astig)
          props.setLensCriRequire(currentLens[0].cri_require)
          props.setLensFlacsRequire(currentLens[0].flacs_require)
          props.setLensConsentId(currentLens[0].consents)
        } else {
          props.setLensName('')
          props.setLensModel('')
          props.setLensLocation('')
          props.setLensHospitalFee('')
          props.setLensSphAb('')
          props.setLensKSphAbResidual('')
          props.setLensCorrectsIntermediateVision('')
          props.setLensCorrectsNearVision('')
          props.setLensGlare('')
          props.setLensTopographerHoaCutoff('')
          props.setLensKAstigMax('')
          props.setLensKAstigMin('')
          props.setLensKAstigResidual('')
          props.setLensBiometerTopographerAstigCutoff('')
          props.setLensBiometerTopographerAxisCutoff('')
          props.setLensCriMinAstig('')
          props.setLensCriMaxAstig('')
          props.setLensCriRequire('')
          props.setLensFlacsRequire('')
          props.setLensConsentId('')
        }
    }, [currentLens[0]]);

    //Don't need to know how much cylinder to correct bc lens picker filters this
    let lensCorrectsAstigmatism = currentLens.length > 0
      ? (currentLens[0].lens_astig_min*1 === 0 || currentLens[0].lens_astig_min === 'dontuse')
        ? 'No'
        : currentLens[0].lens_astig_min*1 > 0
          ? 'Yes'
          : ''
      : ''
      // console.log(lensCorrectsAstigmatism)

    //Final Power
    //Lens set for distance? --> adjust postop distance blur to 0
    let finalPower = (props.lensOption === "Cataract vision" || props.lensOption === '')
      ? p+c
      //Lens set for near? --> adjust postop distance blur to -2.00
      : (props.lensTargetNear === true)
        ? -2.25
        : 0
        // console.log(finalPower + " final power")


    //Final Add
    let finalAdd = (props.lensCorrectsIntermediateVision === "Yes" && props.lensCorrectsNearVision === "Yes")
      //finalAdd should be 0 for lenses that correct intermediate and near
      ? 0
      : (props.lensCorrectsIntermediateVision === "Yes" && props.lensCorrectsNearVision === "No")
        //finalAdd should be 1 for lenses that correct intermediate but not near
        ? +1.00
        : (props.lensOption === "Cataract vision" || props.lensOption === '')
          //finalAdd should be patient's measured preop add if they haven't had surgery
          ? a
          : +2.50;
          // console.log(finalAdd + " final add")
          // console.log(a + " a")

    let distanceBlur =
      ((finalPower*1) > 0 && (finalPower*1)+(finalAdd*1-2.50) < 0)
      //if patient is hyperope preop but can accommodate, then there is no distance blur.  NB: this doesn't truly represent how a young hyperope might see well at distance without glasses
        ? 0
        : (finalPower*1) > 0
          //If patient is a hyperope preop and cannot accommodate enought to correct, then distance blur is difference between hyperopic power and accommodative power.
          ? (finalPower*1)+(finalAdd*1-2.50)
          //Otherwise, patient is plano or myopic (preop or postop) and you just set distance blur equal to finalPower (using absolute power to facilitate blur function)
          : Math.abs(finalPower*1);
          // console.log(distanceBlur + " distance blur")


    let intermediateBlur =
      ((finalPower*1+1.50) > 0 && ((finalPower*1+1.50)+(finalAdd*1-2.50)) <= 0)
        //If patient is more hyperopic than a -1.50 myope preop but can accommodate enough to see computer range, then intermediate blur is 0.  NB: Computer range requires +1.50 more of accommodative power than distance
        ? 0
        : (finalPower*1+1.50) > 0
          //If patient is more hyperopic than a -1.50 myope preop and cannot accommodate enought to correct for computer range (requires +1.50 more diopters of accommodation than distance vision), then intermediate blur is difference between (finalPower+1.50) and accommodative power.
          ? ((finalPower*1+1.50)+(finalAdd*1-2.50))
          //Otherwise, patient is a -1.50 myope or more myopic (preop or postop) and you just set intermediate blur equal to finalPower+1.50 (using absolute power to facilitate blur function)
          : Math.abs(finalPower*1+1.50);
          // console.log(intermediateBlur + " intermediate blur")


    let nearBlur =
      ((finalPower*1+2.50) > 0 && ((finalPower*1+2.50)+(finalAdd*1-2.50)) <= 0)
        //If patient is more hyperopic than a -2.50 myope preop but can accommodate enough to see near range, then near blur is 0.  NB: Near range requires +2.50 more of accommodative power than distance
        ? 0
        : (finalPower*1+2.50) > 0
          //If patient is more hyperopic than a -2.50 myope preop and cannot accommodate enought to correct for near range (requires +2.50 more diopters of accommodation than distance vision), then near blur is difference between (finalPower+2.50) and accommodative power.
          ? ((finalPower*1+2.50)+(finalAdd*1-2.50))
          : (finalPower*1 <= -2.50 && finalPower*1 >= -4.00)
          //If patient is between -2.50 and -4.00, there is no subjective blur.
            ? 0
            //Otherwise, patient is more than a -4.00 myope (preop or postop) and you just set near blur equal to finalPower+4 (using absolute power to facilitate blur function and +3.50 so that you get enough blur)
            : Math.abs(finalPower*1+4.00);
            // console.log(nearBlur + " near blur")


    //make bcva make vision more blurry as well as prescription
    let cataractBlur =
      (props.lensOption === "Cataract vision" || props.lensOption === '')
      ? props.bcva === 'CF'
        ? Math.sqrt((800/20)-1)*3
        : props.bcva === 'HM'
        ? Math.sqrt((2000/20)-1)*3
        : Math.sqrt(((props.bcva*1)/20)-1)*3
        : 0;
      // console.log(cataractBlur + " cataract blur")

    //make select for 0, 1+, 2+, 3+, 4+ NS.  cataractColor the A in RGBA color.  Might have to overlay color on image.
    let sepiaPercent =
      (props.lensOption === "Cataract vision" || props.lensOption === '')
      ? 0.7
      : 0
    //
    //
    // let sepiaBlur = `
    //     ${(0.393 + 0.607 * [1 - cataractColor])} ${(0.769 - 0.769 * [1 - cataractColor])} ${(0.189 - 0.189 * [1 - cataractColor])} 0 0
    //     ${(0.349 - 0.349 * [1 - cataractColor])} ${(0.686 + 0.314 * [1 - cataractColor])} ${(0.168 - 0.168 * [1 - cataractColor])} 0 0
    //     ${(0.0072 - 0.0072 * [1 - cataractColor])} ${(0.534 - 0.534 * [1 - cataractColor])} ${(0.131 + 0.869 * [1 - cataractColor])} 0 0
    //     0 0 0 1 0
    //     `
        // console.log(sepiaBlur + " sepia blur")




    // Use equipmentPreference for astigmatism
    let bioAstig = 
    props.biometerAstig === '' ||
    props.biometerAstig === 'sph' ||
    props.biometerAstig === 'sphere' ||
    props.biometerAstig === ''
    ? 0
    : props.biometerAstig
    
    let topoAstig = 
    props.topographerAstig === '' ||
    props.topographerAstig === 'sph' ||
    props.topographerAstig === 'sphere' ||
    props.topographerAstig === ''
    ? 0
    : props.topographerAstig


    let combAstig =
      (topoAstig*1+bioAstig*1)/2
        // console.log(props.biometer)
        // console.log(props.topographer)
        // console.log(props.equipmentPreference)
        // console.log(equipmentPreference)
        // console.log(combAstig)


    // Use equipmentPreference for axis
    let equipmentPreferenceAxis =
      props.equipmentPreference === props.biometer
      ? props.biometerAxis
      : props.equipmentPreference === props.topographer
        ? props.topographerAxis
        : ''
        // console.log(props.biometer)
        // console.log(props.topographer)
        // console.log(props.equipmentPreference)
        // console.log(equipmentPreference)
        // console.log(equipmentPreferenceAxis)



    //  if preop, use props.cylinder.  if postop, use combAstig
    let cylAstigx =
      props.cylinder === '' ||
      props.cylinder === 'sph'||
      props.cylinder === 'sphere' ||
      props.axis === ''
      ? 0
      : (props.cylinder)*Math.cos(props.axis*(Math.PI/180))

    let cylAstigy =
      props.cylinder === '' ||
      props.cylinder === 'sph'||
      props.cylinder === 'sphere' ||
      props.axis === ''
      ? 0
      : (props.cylinder)*Math.sin(props.axis*(Math.PI/180))


    // console.log("lens_astig_min: " + currentLens[0].lens_astig_min*1)
    // console.log("combAstig: " + combAstig)  

    let astigmatismx  =
      props.lensOption === 'Cataract vision'
      ? cylAstigx
      : (   //If there is so much astigmatism we can't correct all of it
            lensCorrectsAstigmatism === 'Yes'
            &&
            currentLens[0].lens_astig_min*1 <= combAstig
            &&
            currentLens[0].lens_astig_max*1 < combAstig
          )
          ? (combAstig-currentLens[0].lens_astig_max*1)*Math.cos(equipmentPreferenceAxis*(Math.PI/180))
          : (      //If lens corrects astigmatism or has cri that is true
              lensCorrectsAstigmatism === 'Yes'
              // &&
              // currentLens[0].lens_astig_min*1 <= combAstig
              // &&
              // currentLens[0].lens_astig_max*1 >= combAstig
            )
              ||
              props.cri === true
          ? (combAstig - Math.min(props.topographerAstig, props.biometerAstig))*Math.cos(equipmentPreferenceAxis*(Math.PI/180)) // if astigmatism is very different between the machines, you want to show that you will still have some astigmatism
        
          : combAstig*Math.cos(equipmentPreferenceAxis*(Math.PI/180)) // we don't correct astigmatism
       
          //==check which option is being selected with these console.logs==============
          // let astigx1 = (combAstig - Math.min(props.topographerAstig, props.biometerAstig))*Math.cos(equipmentPreferenceAxis*(Math.PI/180))
          
          // let astigx2 = (combAstig-currentLens[0].lens_astig_max*1)*Math.cos(equipmentPreferenceAxis*(Math.PI/180))

          // let astigx3 = combAstig*Math.cos(equipmentPreferenceAxis*(Math.PI/180))

          // console.log("astigmatismx: " + astigmatismx)
          // console.log(astigx1)
          // console.log(astigx2)
          // console.log(astigx3)

          // console.log("lens_astig_MIN: " + currentLens[0].lens_astig_min*1)
          // console.log("lens_astig_MAX: " + currentLens[0].lens_astig_max*1)
          // console.log("combAstig: " + combAstig)

          //============================================================================

      let astigmatismy  =
        props.lensOption === 'Cataract vision'
        ? cylAstigy
        : (
            lensCorrectsAstigmatism === 'Yes'
            &&
            currentLens[0].lens_astig_min*1 <= combAstig
            &&
            currentLens[0].lens_astig_max*1 < combAstig
          )
          ? (combAstig-currentLens[0].lens_astig_max*1)*Math.sin(equipmentPreferenceAxis*(Math.PI/180))
          : (
          lensCorrectsAstigmatism === 'Yes'
          // &&
          // currentLens[0].lens_astig_min*1 <= combAstig
          // &&
          // currentLens[0].lens_astig_max*1 >= combAstig
        )
        ||
        props.cri === true
        ? (combAstig - Math.min(props.topographerAstig, props.biometerAstig))*Math.sin(equipmentPreferenceAxis*(Math.PI/180))
        
          : combAstig*Math.sin(equipmentPreferenceAxis*(Math.PI/180))
      
          // console.log(astigmatismy + " y astigmatism")

      
    let equipmentPreferenceAstig = combAstig

    let biometerTopographerAstigDiff =
      Math.abs(props.biometerAstig*1 - props.topographerAstig*1)
      //console.log(biometerTopographerAstigDiff)

    // need to make input of 180 = 0 and input of '' not count
    let biometerTopographerAxisDiff;
    props.biometerAxis*1 >= 165 && props.topographerAxis*1 <= 15
      ? biometerTopographerAxisDiff = ((props.topographerAxis*1 + 180)-props.biometerAxis*1)
      : props.biometerAxis*1 <= 15 && props.topographerAxis*1 >= 165
        ? biometerTopographerAxisDiff = ((props.biometerAxis*1 + 180) - props.topographerAxis*1)
        : biometerTopographerAxisDiff = Math.abs(props.biometerAxis*1 - props.topographerAxis*1)

    // console.log(biometerTopographerAxisDiff)


    let deviceType = (window.innerWidth <= 900 && window.innerHeight >= window.innerWidth)
    ? 'portrait'
    : (window.innerWidth <= 900 && window.innerHeight <= window.innerWidth)
    ? 'landscape'
    : 'full'

    // console.log(deviceType)



    const ASPECT_RATIO = deviceType === 'portrait'
    ? 1
    : 1821 / 3600; // aspect ratio of height / width
    const [containerHeight, setContainerHeight] = useState(window.innerHeight);
    const [containerWidth, setContainerWidth] = useState(window.innerWidth);
    const containerRef = useRef(null);

    useEffect(() => {
      const handleResize = () => {
        setContainerHeight(window.innerHeight);
        setContainerWidth(window.innerWidth);
      };

      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);

    const aspectHeight = 
      (containerHeight / containerWidth) < ASPECT_RATIO
        ? containerHeight
        : (containerWidth * ASPECT_RATIO);

    const aspectWidth = 
      (containerHeight / containerWidth) > ASPECT_RATIO
        ? containerWidth
        : (containerHeight / ASPECT_RATIO);

    // console.log(containerWidth + "  " + containerHeight)

    useEffect(() => {
      window.scrollTo(0, 0)
    }, [])


    const reduceAstig = Array.isArray(props.lensData)
      ? props.lensData.find((l) => l.lens_name === props.lensOption)?.lens_astig_max ?? null
      : null;

    const nearVision = Array.isArray(props.lensData)
      ? props.lensData.find((l) => l.lens_name === props.lensOption)?.corrects_near_vision ?? null
      : null;

    const intermediateVision = Array.isArray(props.lensData)
      ? props.lensData.find((l) => l.lens_name === props.lensOption)?.corrects_intermediate_vision ?? null
      : null;



    // console.log(reduceAstig)




    //Paralax scrolling for images===============================
    // const [scrollY, setScrollY] = useState(0);

    // useEffect(() => {
    //   const handleScroll = () => {
    //     setScrollY(window.scrollY);
    //   };
  
    //   window.addEventListener('scroll', handleScroll);
  
    //   return () => {
    //     window.removeEventListener('scroll', handleScroll);
    //   };
    // }, []);
  
    // const calculateParallaxOffset = (layer, strength) => {
    //   return -(scrollY * strength) / 100;
    // };

   //==================================================
   const [flicker, setFlicker] = useState('transparent'); // Track flickering state
   const [dysphotopsiaStyle, setDysphotopsiaStyle] = useState(false); // Track flickering state
   const moonRef = useRef(null);

   const handleDysphotopsia = () => {
      setDysphotopsiaStyle(true)

      // Set timeouts to handle the flicker effect
      const timeout1 = setTimeout(() => {
        setFlicker('gray'); // Change color after the first flicker
      }, 100); // After 0.1 seconds

      const timeout2 = setTimeout(() => {
        setFlicker('transparent'); // Change color back to original
      }, 200); // After 0.00 seconds

      const timeout3 = setTimeout(() => {
        setFlicker('gray'); // Change color to gray
      }, 500); // After 0.5 seconds

      const timeout4 = setTimeout(() => {
        setFlicker('transparent'); // Change color back to transparent
      }, 600); // After 0.6 seconds

      const timeout5 = setTimeout(() => {
        setFlicker('gray'); // Change color to gray
      }, 1200); // After 1.2 seconds

      const timeout6 = setTimeout(() => {
        setFlicker('transparent'); // Change color back to transparent
      }, 1300); // After 1.3 seconds

      // Set another timeout to turn off dysphotopsiaStyle after all flickering is done
      const timeout7 = setTimeout(() => {
        setDysphotopsiaStyle(false); // Stop the effect after the last flicker
      }, 2000); // Matches the last flicker timing

      // Clean up the timeouts on component unmount 
      return () => {
        clearTimeout(timeout1);
        clearTimeout(timeout2);
        clearTimeout(timeout3);
        clearTimeout(timeout4);
        clearTimeout(timeout5);
        clearTimeout(timeout6);
        clearTimeout(timeout7);
      };
    }; 


    let rightFlickerStyle = {
      width: '20%', // 20% of the container's width
      position: 'absolute',
      zIndex: '4',
      bottom: `0px`,
      left: 0.18*aspectHeight, // Changed from right to left
      height: aspectHeight,
      borderRadius: '50%', // Creates a circle
      backgroundColor: 'transparent', // Makes the background transparent
      boxShadow: `inset -10px 0px 0px 0px ${flicker}`, // Changed the direction of the shadow to make the crescent open to the left
      MozBoxShadow: `inset -10px 0px 0px 10px ${flicker}`, // Firefox fix for the shadow
      opacity: "0.5"
      
    }

    let leftFlickerStyle = {
      width: '20%', // 20% of the container's width
      position: 'absolute',
      zIndex: '4',
      bottom: `0px`,
      left: -0.38*aspectHeight,
      height: aspectHeight,
      borderRadius: '50%', // Creates a circle
      backgroundColor: 'transparent', // Makes the background transparent
      boxShadow: `inset 10px 0px 0px 0px ${flicker}`, // Creates the crescent shadow with white color
      MozBoxShadow: `inset 10px 0px 0px 10px ${flicker}`, // Firefox fix for the shadow
      opacity: "0.5"
    }

//===============================================================
    const [showOverview, setShowOverview] = useState(true)



   //==================================================

// console.log('aspect height: ' + aspectHeight)
// console.log('aspect width: ' + aspectWidth)
 
  return( 
    <>
  {
    props.userType === 'qrpt' && showOverview === true
    ? 
      <>
        <Overview
          userType={props.userType}
          setShowOverview={setShowOverview}
          setCurrentVision={props.setCurrentVision}
          setGoalVision={props.setGoalVision}
          spanish={props.spanish}
          setSpanish={props.setSpanish}
        />
      </>
    : 
     <div style={{
      width: '100vw',
      background: "#FFF",
      padding: '0 0 0px 0',
      }}>
  
        {props.userType === 'qrpt'
          ? 
            <MdOutlineArrowBackIosNew
              onClick={() => setShowOverview(true)}
              style={{
                color: '#007bff',
                fontSize: '82px',
                cursor: 'pointer',
                position: 'fixed',
                top: '10%',
                left: '0px',
                zIndex: '12',
              }}
            />
          : 
          <div
            onClick={() => {
              props.setLensOption('Cataract vision')
              props.setSelectedColor('#000')
              props.setMonofocalSelected(false)
              props.setToricSelected(false)
              props.setBestSelected(false)
            }}
          >
            <BackArrow
              linkTo='/patientinfo'
            />
          </div>
        }

      
      <div style={{display: 'flex'}}>
        <div style={{width: deviceType === 'full' ? '7vw' : '0vw',}}></div>

            
          <div style={
            deviceType === 'portrait' 
            ? {width: '100vw'}
            : {
                display: 'flex', 
                justifyContent: 'space-evenly', 
                width: deviceType === 'full' ? '93vw' : '100vw',
              }
          }>
            
            <div style={
              deviceType === 'portrait' 
              ? 
              {
                width: '100vw'
              }
              : deviceType === 'landscape' 
              ?
              {
                display: 'flex', 
                justifyContent: 'center', 
                position: 'relative',
                width: '70%',
                padding: '10px',
                margin: '0px 0 40px 0',
              }
              : 
              {
                display: 'flex', 
                justifyContent: 'center', 
                position: 'relative',
                width: '70%',
                padding: '10px',
                margin: '40px 0 40px 0',
              }
            }>
              {/* <p>Simulated vision without glasses</p> */}
              <div
                style={{
                  position: 'fixed',
                  top: 0,
                  left: deviceType === 'full' ? '7vw' : deviceType === 'portrait' ? '8vw': '0vw',
                  width: deviceType === 'full' ? '65vw' : deviceType === 'landscape' ? '60vw' : '100vw',
                  height: deviceType === 'portrait' ? '50vh' : '100vh',
                  display: 'flex',
                  alignItems: deviceType === 'portrait' ? 'end' : 'center',
                  justifyContent: 'center',
                  zIndex: 1,
                }}
              >

                <div style={{width: aspectHeight*0.6}}>
              {  
                props.refractive === true || props.refractive === 'sortof' || props.lensOption === 'Cataract vision'
                ?             
                  <div 
                    style={{
                      position: 'relative', 
                      width: '100%', 
                      height: 0.7*aspectHeight,
                      margin: deviceType === 'full' ? '80px 0 0 0' : '0px 0 0 0',
                    }}
                  >
    
<img
                      className='snellenChart'
                      style={{
                        position: 'absolute',
                        zIndex: '1',
                        bottom: `${aspectHeight*0.2 + astigmatismy*3}px`,
                        left: `${-0.10*aspectHeight+astigmatismx*3}px`,
                        maxHeight: aspectHeight*0.5,
                        opacity: '48%',
                        filter: `blur(${distanceBlur*1.5 + cataractBlur*1}px) sepia(${sepiaPercent})`,
                        // transform: `translate3d(0, ${calculateParallaxOffset('near', 0)}px, 0)`,
                      }}
                      src={snellenChart}
                      alt="Snellen"
                    />
                    <img
                      className='snellenChart'
                      style={{
                        position: 'absolute',
                        zIndex: '1',
                        bottom: `${aspectHeight*0.2 - astigmatismy*3}px`,
                        left:`${-0.10*aspectHeight-astigmatismx*3}px`,
                        maxHeight: aspectHeight*0.5,
                        opacity: '48%',
                        filter: `blur(${distanceBlur*1.5 + cataractBlur*1}px) sepia(${sepiaPercent})`,
                        // transform: `translate3d(0, ${calculateParallaxOffset('near', 0)}px, 0)`,
                      }}
                      src={snellenChart}
                      alt="Snellen"
                    />

                    <img
                      className='snellenChart'
                      style={{
                        position: 'absolute',
                        zIndex: '0',
                        bottom: `${aspectHeight*0.2 + 0}px`,
                        left: -0.10*aspectHeight,
                        maxHeight: aspectHeight*0.5,
                        opacity: '48%',
                        filter: `blur(${distanceBlur*1.5 + cataractBlur*1}px) sepia(${sepiaPercent})`,
                      }}
                      src={snellenChart}
                      alt="Snellen"
                    />

                    <img
                        className='nearImage'
                        style={{
                          position: 'absolute',
                          zIndex: '5',
                          bottom: `${-astigmatismy*2}px`,
                          left:`${-0.30*aspectHeight-astigmatismx*2}px`,
                          maxHeight: (deviceType === 'portrait' && (props.lensTargetNear === true || props.lensCorrectsNearVision === 'Yes')) ? aspectHeight*0.58 : aspectHeight*0.45,
                          opacity:'28%',
                          filter: `blur(${(nearBlur*2.5 + cataractBlur*1)*0.6}px) sepia(${sepiaPercent*0.5})`,
                          // transform: `translate3d(0, ${calculateParallaxOffset('near', 10)}px, 0)`
                        }}
                        src={nearImage}
                        alt="Near"
                        />

                      <img
                        className='nearImage'
                        style={{
                          position: 'absolute',
                          zIndex: '5',
                          bottom: `${astigmatismy*2}px`,
                          left:`${-0.30*aspectHeight+astigmatismx*2}px`,
                          maxHeight: (deviceType === 'portrait' && (props.lensTargetNear === true || props.lensCorrectsNearVision === 'Yes')) ? aspectHeight*0.58 : aspectHeight*0.45,
                          opacity:'28%',
                          filter: `blur(${(nearBlur*2.5 + cataractBlur*1)*0.6}px) sepia(${sepiaPercent*0.5})`,
                          // transform: `translate3d(0, ${calculateParallaxOffset('near', 10)}px, 0)`
                        }}
                        src={nearImage}
                        alt="Near"
                        />

                      <img
                        className='nearImage'
                        style={{
                          position: 'absolute',
                          zIndex: '4',
                          bottom: '0px',
                          left: -0.30*aspectHeight,
                          maxHeight: (deviceType === 'portrait' && (props.lensTargetNear === true || props.lensCorrectsNearVision === 'Yes')) ? aspectHeight*0.58 : aspectHeight*0.45,
                          opacity:'100%',
                          filter: `blur(${(nearBlur * 2.5 + cataractBlur * 1) * 0.6}px) sepia(${sepiaPercent*0.5})`,
                        }}
                        src={nearImage}
                        alt="Near"
                      />

    
                      <NightSimulator
                        astigmatismx={astigmatismx}
                        astigmatismy={astigmatismy}
                        intermediateBlur={intermediateBlur}
                        distanceBlur={distanceBlur}
                        cataractBlur={cataractBlur}
                        lensCorrectsAstigmatism={lensCorrectsAstigmatism}
                        lensCorrectsNearVision={props.lensCorrectsNearVision}
                        lensCorrectsIntermediateVision={props.lensCorrectsIntermediateVision}
                        lensGlare={props.lensGlare}
                        lensOption={props.lensOption}
                        sepiaPercent={sepiaPercent}
                        lensData={props.lensData}
                        aspectHeight={aspectHeight}
                        aspectWidth={aspectWidth}
                        equipmentPreferenceAstig={equipmentPreferenceAstig}
                        equipmentPreferenceAxis={equipmentPreferenceAxis}
                        deviceType={deviceType}
                        refractive={props.refractive}
                      />


                      
                      <div style= {{width: '100%'}}>
                        <div 
                          ref={moonRef}
                          style={props.side === 'RIGHT'
                            ? rightFlickerStyle
                            : leftFlickerStyle
                          }
                        >
                        </div>
                      </div>


                  

                  </div>

                  : 
                  <div 
                    style={{
                      position: 'relative', 
                      width: '100%', 
                      height: 0.7*aspectHeight,
                      margin: deviceType === 'full' ? '80px 0 0 0' : '0px 0 0 0',
                    }}
                  >
                    <img
                      src={Glasses}
                      style={
                         deviceType === 'portrait'
                        ? 
                          {
                            position: 'absolute',
                            zIndex: '3',
                            bottom: `${0.2*aspectHeight}px`,
                            left:`${-0.25*aspectHeight-astigmatismx*2}px`,
                            maxHeight: aspectHeight*0.55,
                          }
                        : 
                          {
                            position: 'absolute',
                            zIndex: '3',
                            bottom: `${0.2*aspectHeight}px`,
                            left:`${-0.3*aspectHeight-astigmatismx*2}px`,
                            maxHeight: aspectHeight*0.55,
                          }
                        }
                    />
                  </div>
                }
                  

{/* <p>{props.expectedTest}</p>  */}


                {
                  props.refractive || props.lensOption === 'Cataract vision'
                  ? 
                    <p
                      style={
                        deviceType === 'portrait'
                        ? {
                            margin: '5px 0 0 0',
                            padding: '2px 10px',
                            position: 'absolute',
                            borderRadius: deviceType === 'portrait' ? '5px' : "5px 5px 0 0",
                            left: '12px',
                            bottom: deviceType === 'portrait' ? '0px' : '48px',
                            background: '#FFF',
                            zIndex: '4',
                          }
                        : {
                            margin: '15px 0 0 0',
                          }
                      }
                    >
                      {props.spanish === true ? 'Visión simulada SIN gafas' : 'Simulated vision WITHOUT glasses'}
                    </p>
                  : 
                    <p
                      style={
                        deviceType === 'portrait'
                        ? {
                            margin: '5px 0 0 0',
                            position: 'absolute',
                            left: '70px',
                            bottom: '48px',
                            background: '#FFF',
                          }
                        : {
                            margin: '5px 0 0 0',
                          }
                      }
                    >
                      {props.spanish === true ? 'Necesitarás usar gafas todo el tiempo' : 'Use glasses full time'}  
                    </p>
                  }
                </div>
              </div>            
            </div>
            <div
              style={{
                minWidth: deviceType === 'full' ? '420px' : '46%',
                maxWidth: '420px',
                padding: deviceType === 'full' ? '10px' : '0px',
                margin: deviceType === 'full' ? '0px 20px 0px 0' : '0px 10px 0px 0',
                position: 'relative',
                zIndex: deviceType === 'portrait' ? '0' : '6',
              }} 
            >

              <div 
                style={
                  deviceType === 'portrait' 
                  ? {
                      position: 'fixed', margin: '47vh 0 0 0',
                      width: '100%',
                    } 
                  : {}
                }
              >
                
               
              <LensPicker
                biometerTopographerAstigDiff={biometerTopographerAstigDiff}
                biometerTopographerAxisDiff={biometerTopographerAxisDiff}
                lensData={props.lensData}
                choseBestLens={props.choseBestLens}
                setChoseBestLens={props.setChoseBestLens}
                lensOption={props.lensOption}
                setLensOption={props.setLensOption}
                lensHospitalFee={props.lensHospitalFee}
                setLensHospFee={props.setLensHospFee}
                setLensPhysFee={props.setLensPhysFee}
                lensSphAb={props.lensSphAb}
                contraindications={props.contraindications}
                biometer={props.biometer}
                biometerAstig={props.biometerAstig}
                biometerAxis={props.biometerAxis}
                biometerStdDev={props.biometerStdDev}
                chordMuTotal={props.chordMuTotal}
                topographer={props.topographer}
                topographerAstig={props.topographerAstig}
                topographerAxis={props.topographerAxis}
                topographerSphAb={props.topographerSphAb}
                topographerHoa={props.topographerHoa}
                sphAbTarget={props.sphAbTarget}
                hoaMaxPreference={props.hoaMaxPreference}
                equipmentPreference={props.equipmentPreference}
                physicianName={props.physicianName}
                lensCorrectsNearVision={props.lensCorrectsNearVision}
                lensCorrectsIntermediateVision={props.lensCorrectsIntermediateVision}
                lensTopographerHoaCutoff={props.lensTopographerHoaCutoff}
                lensTargetNear={props.lensTargetNear}
                setLensTargetNear={props.setLensTargetNear}
                lensKAstigMin={props.lensKAstigMin}
                lensKAstigMax={props.lensKAstigMax}
                lensKAstigResidual={props.lensKAstigResidual}
                lensBiometerTopographerAstigCutoff={props.lensBiometerTopographerAstigCutoff}
                lensBiometerTopographerAxisCutoff={props.lensBiometerTopographerAxisCutoff}
                equipmentPreferenceAstig={equipmentPreferenceAstig}

                lensCriMinAstig={props.lensCriMinAstig}
                lensCriMaxAstig={props.lensCriMaxAstig}
                lensCriRequire={props.lensCriRequire}
                cri={props.cri}
                setCri={props.setCri}
                criOffer={props.criOffer}
                criAlwaysOn={props.criAlwaysOn}
                setCriAlwaysOn={props.setCriAlwaysOn}
                criAllowToggle={props.criAllowToggle}
                setCriAllowToggle={props.setCriAllowToggle}

                flacs={props.flacs}
                setFlacs={props.setFlacs}
                flacsOffer={props.flacsOffer}
                lensFlacsRequire={props.lensFlacsRequire}
                flacsAlwaysOn={props.flacsAlwaysOn}
                setFlacsAlwaysOn={props.setFlacsAlwaysOn}
                flacsAllowToggle={props.flacsAllowToggle}
                setFlacsAllowToggle={props.setFlacsAllowToggle}

                oopTotal={props.oopTotal}
                setOopTotal={props.setOopTotal}
                oopPhysician={props.oopPhysician}
                setOopPhysician={props.setOopPhysician}
                oopHospital={props.oopHospital}
                setOopHospital={props.setOopHospital}

                financing={props.financing}
                setFinancing={props.setFinancing}
              
                setPtLensList={props.setPtLensList}
                selectedColor={props.selectedColor}
                setSelectedColor={props.setSelectedColor}
                staticLensListOptions={props.lensData}
                
                onlyCompatible={props.onlyCompatible}
                setOnlyCompatible={props.setOnlyCompatible}

                monofocalLens={props.monofocalLens}
                setMonofocalLens={props.setMonofocalLens}
                toricLens={props.toricLens}
                setToricLens={props.setToricLens}
                edofLens={props.edofLens}
                setEdofLens={props.setEdofLens}
                edofToricLens={props.edofToricLens}
                setEdofToricLens= {props.setEdofToricLens}
                trifocalLens={props.trifocalLens}
                setTrifocalLens={props.setTrifocalLens}
                trifocalToricLens={props.trifocalToricLens}
                setTrifocalToricLens={props.setTrifocalToricLens}

                monofocalSelected={props.monofocalSelected}
                setMonofocalSelected={props.setMonofocalSelected}
                toricSelected={props.toricSelected}
                setToricSelected={props.setToricSelected}
                bestSelected={props.bestSelected}
                setBestSelected={props.setBestSelected}

                handleDysphotopsia={handleDysphotopsia}

                acknowledgeRba={props.acknowledgeRba}
                setAcknowledgeRba={props.setAcknowledgeRba}

                userType={props.userType}
                deviceType={deviceType}

                refractive={props.refractive}
                setRefractive={props.setRefractive}
                refractiveFee={props.refractiveFee}

                spanish={props.spanish}
                setSpanish={props.setSpanish}

                cataractAddOn={props.cataractAddOn}

                encryptionKey={props.encryptionKey}
                setEncryptionKey={props.setEncryptionKey}
                cipherTextPt={props.cipherTextPt}
                setCipherTextPt={props.setCipherTextPt}
                cipherTextMd={props.cipherTextMd}
                setCipherTextMd={props.setCipherTextMd}
                qrToken={props.qrToken}
                setQrToken={props.setQrToken}

                power={props.power}
                cylinder={props.cylinder}
                axis={props.axis}
                add={props.add}

                currentVision={props.currentVision}
                goalVision={props.goalVision}

              /> 
                            
  
              

              
              </div>
            </div> 
          </div>
          </div>
      </div>
              }
</>
  )
}